import moment from 'moment-timezone';

/**
 * Return a moment instance with the config
 * @param {string} expression timeDelta expression
 *
 * @return moment instance
 */
function time(expression: string) {
  const m = moment();
  const agoRegex = new RegExp('[ago|AGO]', 'g');
  const yearsRegex = new RegExp('(\\d*)[y|Y]', 'g');
  const yearMatches = yearsRegex.exec(expression);

  const ago = agoRegex.test(expression);

  if (yearMatches) {
    if (ago) {
      m.subtract(+yearMatches[1], 'years');
    } else {
      m.add(+yearMatches[1], 'years');
    }
  }

  return m;
}

export default time;
